import { TranslateFn } from 'hooks/useTranslate';
import { Partner, TradingOfferOperation } from 'types';
import { getOperationType } from './getOperationType';

const getPartyName = (party: string | Partial<Partner>) => {
  if (typeof party === 'string') return '-';
  return party?.name || '-';
};

export const getCounterparty = (
  operation: TradingOfferOperation,
  currentPartnerId: string,
  t: TranslateFn
): string => {
  const isBuyer = getOperationType(operation, currentPartnerId) === 'BUY';
  const counterparty = isBuyer ? operation.seller : operation.buyer;
  const role = isBuyer ? t('Seller') : t('Buyer');
  return `${role}: ${getPartyName(counterparty)}`;
};
